/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RapportHopeParameterValuesDto
 */
export interface RapportHopeParameterValuesDto {
    /**
     * 
     * @type {string}
     * @memberof RapportHopeParameterValuesDto
     */
    label?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportHopeParameterValuesDto
     */
    value?: string | null;
}

/**
 * Check if a given object implements the RapportHopeParameterValuesDto interface.
 */
export function instanceOfRapportHopeParameterValuesDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RapportHopeParameterValuesDtoFromJSON(json: any): RapportHopeParameterValuesDto {
    return RapportHopeParameterValuesDtoFromJSONTyped(json, false);
}

export function RapportHopeParameterValuesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RapportHopeParameterValuesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : json['label'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function RapportHopeParameterValuesDtoToJSON(value?: RapportHopeParameterValuesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'value': value.value,
    };
}

